/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Snap state:
 * * `NEW` - New snap
 * * `RECEIPT_FRAUD` - Error state - Submitted by collector was engaged in cheating
 * * `RECEIPT_EMPTY` - Error state - JSON can't be parsed or image_url is absent. A receipt without line items is also considered to be empty
 * * `RECEIPT_INVALID` - Error state - Some of required fields missing (receiptDateTime/total/brand)
 * * `RECEIPT_LOW_QUALITY` - Error state - Required fields (receiptDateTime/total/brand) have low confidence scores
 * * `RECEIPT_TOO_OLD` - Error state - Purchase date on receipt is too old
 * * `RETAILER_NOT_ELIGIBLE` - Error state - Receipt brand is absent in available retailers
 * * `DUPLICATE_RECEIPT` - Error state - Submitted receipt is duplicate
 * * `POTENTIAL_DUPLICATE` - Snap is potential duplicate (requires confirmation)
 * * `NO_MATCHED_OFFERS` - Snap matching completed without matches
 * * `CORRECTION_REQUIRED` - Snap requires correction (contain at least one PARTIAL_MATCH)
 * * `MATCHING_SUCCESSFUL` - Snap matching completed with at least one FULL_MATCH/MANUAL_MATCH and without PARTIAL_MATCH-es
 * * `ISSUED` - Final state. Snap has at least one match and all matches have SUCCESS/PENDING issuance status
 *
 */
export enum SnapState {
    NEW = 'NEW',
    RECEIPT_FRAUD = 'RECEIPT_FRAUD',
    RECEIPT_EMPTY = 'RECEIPT_EMPTY',
    RECEIPT_INVALID = 'RECEIPT_INVALID',
    RECEIPT_LOW_QUALITY = 'RECEIPT_LOW_QUALITY',
    RECEIPT_TOO_OLD = 'RECEIPT_TOO_OLD',
    RETAILER_NOT_ELIGIBLE = 'RETAILER_NOT_ELIGIBLE',
    DUPLICATE_RECEIPT = 'DUPLICATE_RECEIPT',
    POTENTIAL_DUPLICATE = 'POTENTIAL_DUPLICATE',
    NO_MATCHED_PRODUCTS = 'NO_MATCHED_PRODUCTS',
    CORRECTION_REQUIRED = 'CORRECTION_REQUIRED',
    MATCHING_SUCCESSFUL = 'MATCHING_SUCCESSFUL',
    NO_MATCHED_OFFERS = 'NO_MATCHED_OFFERS',
    ISSUED = 'ISSUED',
}
